import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-100" }
const _hoisted_2 = { class: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8 lg:grid lg:grid-cols-3 lg:gap-x-8" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div><h2 class=\"text-base font-semibold text-teal-600 uppercase tracking-wide\"> Everything you need </h2><p class=\"mt-2 text-3xl font-extrabold text-gray-900\"> Flexible Living </p><div class=\"mt-4 text-lg text-gray-500\"><p> Each of the main house and cabanas is a home which can be rented separately; each with living areas, full bathrooms, well equipped kitchens, cable TV, private dining patios, and private gardens.</p><p><br><span class=\"text-black\">Cabanas</span> are perfect for a couple seeking a romantic weekend getaway, or, for families with 2 small children. Each cabana sleeps up to 4. </p><br><p><span class=\"text-black\">The main house</span> is ideal for 2 couples or a family with older children. The main house sleeps up to 6. </p></div></div>", 1)
const _hoisted_4 = { class: "mt-12 lg:mt-0 lg:col-span-2" }
const _hoisted_5 = { class: "space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-3 sm:grid-flow-col sm:gap-x-6 sm:gap-y-10 lg:gap-x-8" }
const _hoisted_6 = { class: "ml-9 text-lg leading-6 font-medium text-gray-900" }
const _hoisted_7 = { class: "mt-2 ml-9 text-base text-gray-500" }

import { CheckIcon } from "@heroicons/vue/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccommodationFeatures',
  setup(__props) {




const features = [
  {
    name: "All the luxuries",
    description:
      "A pool, A labyrinth, Walking paths, Proximity to the beaches, walking trails and tourist services.",
  },
   {
    name: "Here to support you",
    description:
      "Our manager, Silja, will meet you at the airport. She and her family live onsite. You will also see the familiar faces of our other staff, Susan, Zambo and Kurtney daily during the week.",
  },
   {
    name: "Provide you with a healthy environment",
    description:
      "Rooms which open directly to the outside gardens; Water which is additionally filtered and disinfected; Great natural ventilation with wooden louvres and high ceilings; Bedrooms with air-conditioning; Sparkling clean.",
  },
  {
    name: "Fully equipped",
    description:
      "Guest Parking; High speed internet freely available throughout; Kitchens with all basic appliances; Cable TV",
  },
  {
    name: "Top Rated",
    description:
      "Previous guests have consistently rated the service provided by Top O’ Tobago staff as ‘superb’! Top O’ Tobago has earned a five star rating in more than 93% of its Trip Advisor reviews and has earned Trip Advisor Excellence Recommendations from 2013 to 2020.",
  },
 
  // {
  //   name: "Help you vacation",
  //   description:
  //     "We provide snorkels, beach towels, beach chairs, and anything else that we could think of to make your beach family vacation a success.",
  // },
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("dl", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (feature) => {
            return _createElementVNode("div", {
              key: feature.name,
              class: "relative"
            }, [
              _createElementVNode("dt", null, [
                _createVNode(_unref(CheckIcon), {
                  class: "absolute h-6 w-6 text-green-500",
                  "aria-hidden": "true"
                }),
                _createElementVNode("p", _hoisted_6, _toDisplayString(feature.name), 1)
              ]),
              _createElementVNode("dd", _hoisted_7, _toDisplayString(feature.description), 1)
            ])
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})